import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getIsFormActive = createSelector(
  (state: RootState) => state.app,
  app => app.isFormActive,
)
